import { Component } from '@angular/core';

@Component({
  selector: 'a18-list',
  templateUrl: './a18-list.component.html',
  styleUrl: './a18-list.component.scss'
})
export class A18ListComponent {

}
